import { Box, Typography } from '@mui/material'
import { gradientBrand } from '../theme/brand'

const LOGO_SRC = '/logo.png'
const LOGO_ALT = 'Phiên Toà Giả Định - Công Lý Giới'

interface LogoProps {
  variant?: 'sidebar' | 'header' | 'compact'
  showText?: boolean
}

export default function Logo({ variant = 'sidebar', showText = true }: LogoProps) {
  if (variant === 'compact') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          component="img"
          src={LOGO_SRC}
          alt={LOGO_ALT}
          sx={{
            width: 40,
            height: 40,
            objectFit: 'contain',
            filter: 'drop-shadow(0 2px 6px rgba(20, 78, 140, 0.18))',
          }}
        />
        {showText && (
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              background: gradientBrand,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            E-Court
          </Typography>
        )}
      </Box>
    )
  }

  if (variant === 'header') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          component="img"
          src={LOGO_SRC}
          alt={LOGO_ALT}
          sx={{
            width: 36,
            height: 36,
            objectFit: 'contain',
            filter: 'drop-shadow(0 2px 6px rgba(20, 78, 140, 0.18))',
          }}
        />
        {showText && (
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                lineHeight: 1.2,
                background: gradientBrand,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              E-Court
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'text.secondary',
                fontSize: '0.7rem',
                fontWeight: 500,
                letterSpacing: 0.5,
              }}
            >
              N2NAI
            </Typography>
          </Box>
        )}
      </Box>
    )
  }

  // Sidebar variant (default) - Compact version
  return (
    <Box
      sx={{
        p: 2,
        background: gradientBrand,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        boxShadow: '0 2px 12px rgba(20, 78, 140, 0.28)',
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: 2,
          background: 'rgba(255, 255, 255, 0.95)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          flexShrink: 0,
          p: 0.5,
        }}
      >
        <Box
          component="img"
          src={LOGO_SRC}
          alt={LOGO_ALT}
          sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </Box>
      {showText && (
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              color: 'white',
              lineHeight: 1.2,
              fontSize: '0.95rem',
              textShadow: '0 1px 2px rgba(0,0,0,0.2)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            E-Court
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              fontWeight: 600,
              letterSpacing: 1.5,
              fontSize: '0.65rem',
              textTransform: 'uppercase',
            }}
          >
            N2NAI
          </Typography>
        </Box>
      )}
    </Box>
  )
}
